import { useState, useEffect, useRef } from 'react';

export function AnimatedCounter({ value, prefix = '', suffix = '', label }) {
  const [count, setCount] = useState(0);
  const ref = useRef(null);
  const [hasAnimated, setHasAnimated] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasAnimated) {
          setHasAnimated(true);
          const duration = 2000;
          const frameDuration = 1000 / 60;
          const totalFrames = Math.round(duration / frameDuration);
          const easeOutQuad = t => t * (2 - t);
          
          let frame = 0;
          const interval = setInterval(() => {
            frame++;
            const progress = easeOutQuad(frame / totalFrames);
            const currentCount = Math.round(value * progress);
            
            if (frame === totalFrames) {
              setCount(value);
              clearInterval(interval);
            } else {
              setCount(currentCount);
            }
          }, frameDuration);
          
          return () => clearInterval(interval);
        }
      },
      { threshold: 0.5 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [value, hasAnimated]);

  return (
    <div ref={ref} className="text-center group">
      <div className="text-xl sm:text-2xl md:text-3xl font-black font-accent text-transparent bg-clip-text bg-gradient-to-br from-cyan-400 to-blue-600 drop-shadow-md group-hover:scale-110 transition-transform duration-300 whitespace-nowrap">
        {prefix}{count.toLocaleString('en-IN')}{suffix}
      </div>
      <div className="text-gray-700 dark:text-white/70 mt-3 font-medium uppercase tracking-wider text-sm">{label}</div>
    </div>
  );
}
